import { MenubarMobile_ } from '../../areas/Menubar/Mobile/MenubarMobile_';
export class MobileComponents {
    MenubarMobile_ = MenubarMobile_;
}
